import React from 'react';
import { DataTable } from 'react-native-paper';
import PropTypes from 'prop-types';

function WaterUseDataTableRow({ crop, unit }) {
  return (
    <DataTable.Row>
      <DataTable.Cell>{crop.name}</DataTable.Cell>
      <DataTable.Cell>{crop[unit].growingWaterNeeds}</DataTable.Cell>
      <DataTable.Cell>{crop[unit].monthlyWaterNeeds}</DataTable.Cell>
      <DataTable.Cell>{crop.monthsGrown}</DataTable.Cell>
      <DataTable.Cell>{crop.typicalPlantingTime}</DataTable.Cell>
    </DataTable.Row>
  );
}

WaterUseDataTableRow.propTypes = {
  crop: PropTypes.object,
  unit: PropTypes.string,
};

export default WaterUseDataTableRow;
